import { ArticleApi, GetAllArticleParams } from '@apis/ArticleApi';
import { ArticleList } from '@models/Article';
import { Pagination } from '@models/Pagination';
import { SagaPayload } from '@utils/typescript';
import { call, put, takeLatest } from 'redux-saga/effects';
import { articlesFetch, articlesSet } from './action';

function* handleArticlesFetch({ payload }: SagaPayload<GetAllArticleParams>) {
  try {
    const [articles] = (yield call(ArticleApi.getAll, payload)) as [ArticleList[], Pagination];
    yield put(articlesSet({ articles }));
  } catch {
    yield put(articlesSet({ articles: [] }));
  }
}

export default function* () {
  yield takeLatest(articlesFetch, handleArticlesFetch);
}
